import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useCheckListToggle } from 'common/Prose/Toolbar/hooks/useCheckListToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const CheckListItem = observer(({ withLabel = false }: { withLabel?: boolean }) => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useCheckListToggle(view)
  const label = 'Checklist'
  const tooltip = withLabel ? undefined : { label }

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.CheckList} />}
      label={withLabel ? label : ''}
      ariaLabel={label}
      active={active}
      disabled={disabled}
      handleClick={handleClick}
      tooltip={tooltip}
    />
  )
})
